import VideoPreviousIcon from '@atlaskit/icon/core/video-previous';
import * as React from 'react';

export function SvgSkipBack() {
  return <VideoPreviousIcon label="" testId="ads-refreshed-icon" />;
}
